import { callApi } from "@src/api/callApi"

export const postFleetsUuidBatchDisablePowersave = (partnerUuid: string, fleetUuid: string) =>
  callApi<null, { success: boolean }>({
    method: "POST",
    path: `/partner/${partnerUuid}/fleets/${fleetUuid}/batch_disable_powersaving`,
  })
